export const detailsHasPermissions = {
    namespaced: true,

    state: {
        details: {
            msg: '',
            title: ''
        }
    },

    getters: {
        getDetails(state) {
            return state.details
        },
    },

    mutations: {
        SET_DETAILS(state, payload) {
            if (payload.msg) {
                state.details = payload
            } else state.details.msg = payload
        }
    },

    actions: {
        updateDetails({ commit }, payload) {
            commit('SET_DETAILS', payload)
        }
    }
}